module.exports = __webpack_public_path__ + "img/dl (15).90e30242.jpg";